import React from 'react';

/**
 * PatientAdminTable
 * Following the Constitution: Table-only data display and Action Select pattern.
 */
const PatientAdminTable = ({ data, openview, openedit }) => {
  return (
    <table className="grid">
      <thead>
        <tr>
          <th style={{ width: '50px' }}>Action</th>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Last Visit</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {data.map((patient, i) => (
          <tr key={patient._id || i}>
            <td>
              {/* Institutional-Grade Action Select pattern */}
              <select 
                className="action-select" 
                value="" 
                onChange={(e) => {
                  if (e.target.value === "View") openview(patient);
                  if (e.target.value === "Edit") openedit(patient);
                }}
              >
                <option value="" disabled>{i + 1}</option>
                <option value="View">View</option>
                <option value="Edit">Edit</option>
              </select>
            </td>
            <td>{patient.name}</td>
            <td>{patient.phonenumber}</td>
            <td>{patient.lastvisit || "N/A"}</td>
            <td>
              <span className={`status-badge ${patient.status?.toLowerCase() || 'active'}`}>
                {patient.status || "Active"}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PatientAdminTable;